import { defineAsyncComponent } from 'vue';
import { GlDisclosureDropdown, GlButtonGroup } from '@gitlab/ui';
export default {
    name: 'CommitMessageDropdown',
    components: {
        GlButtonGroup,
        GlDisclosureDropdown,
        AiCommitMessage: defineAsyncComponent(()=>import('ee_component/vue_merge_request_widget/components/ai_commit_message.vue'))
    },
    props: {
        commits: {
            type: Array,
            required: true
        },
        aiCommitMessageEnabled: {
            type: Boolean,
            required: false,
            default: false
        },
        mrId: {
            type: Number,
            required: false,
            default: null
        }
    },
    emits: [
        'append',
        'input'
    ],
    computed: {
        dropdownItems () {
            return this.commits.map((commit)=>({
                    text: commit.title,
                    extraAttrs: {
                        text: commit.shortId || commit.short_Id
                    },
                    action: ()=>{
                        this.$emit('input', commit.message);
                    }
                }));
        }
    }
};
